module.exports = __webpack_public_path__ + "static/media/layer-group.e285fdf2.png";